import { Form, InputNumber } from '@arco-design/web-react'
import JsonField, { validateJson } from '../JsonField'
import InstantSwitch from '../InstantSwitch'
import SettingSectionCard from '../SettingSectionCard'
import type { OptionsAPI } from '../useOptions'

const KEYS = [
  'gemini.safety_settings',
  'gemini.version_settings',
  'gemini.supported_imagine_models',
  'gemini.function_call_thought_signature_enabled',
  'gemini.remove_function_response_id_enabled',
  'gemini.thinking_adapter_enabled',
  'gemini.thinking_adapter_budget_tokens_percentage',
]

export default function GeminiModelSection({ options }: { options: OptionsAPI }) {
  const { get, getNumber, patch } = options

  const validate = () => {
    for (const k of ['gemini.safety_settings', 'gemini.version_settings', 'gemini.supported_imagine_models']) {
      const msg = validateJson(get(k))
      if (msg) return `${k}: ${msg}`
    }
    return null
  }

  return (
    <SettingSectionCard title="Gemini 模型" keys={KEYS} options={options} validate={validate}>
      <Form layout="vertical">
        <Form.Item label="Safety Settings JSON">
          <JsonField value={get('gemini.safety_settings')} onChange={(v) => patch({ 'gemini.safety_settings': v })} rows={4} />
        </Form.Item>
        <Form.Item label="Version Settings JSON">
          <JsonField value={get('gemini.version_settings')} onChange={(v) => patch({ 'gemini.version_settings': v })} rows={4} />
        </Form.Item>
        <Form.Item label="Supported Imagine Models JSON">
          <JsonField
            value={get('gemini.supported_imagine_models')}
            onChange={(v) => patch({ 'gemini.supported_imagine_models': v })}
            rows={4}
          />
        </Form.Item>
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="Function Call Thought Signature">
            <InstantSwitch options={options} optionKey="gemini.function_call_thought_signature_enabled" defaultChecked />
          </Form.Item>
          <Form.Item label="Remove Function Response ID">
            <InstantSwitch options={options} optionKey="gemini.remove_function_response_id_enabled" defaultChecked />
          </Form.Item>
          <Form.Item label="Thinking Adapter">
            <InstantSwitch options={options} optionKey="gemini.thinking_adapter_enabled" />
          </Form.Item>
          <Form.Item label="Thinking Budget 比例">
            <InputNumber
              style={{ width: 240 }}
              min={0}
              max={1}
              step={0.1}
              value={getNumber('gemini.thinking_adapter_budget_tokens_percentage', 0.6)}
              onChange={(v) => patch({ 'gemini.thinking_adapter_budget_tokens_percentage': v ?? 0.6 })}
            />
          </Form.Item>
        </div>
      </Form>
    </SettingSectionCard>
  )
}
